import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    getDocumentSettings({ commit, dispatch }, partyType) {
      return ajax
        .get(
          `BusinessParties/api/DocumentSettingsQuery/by-party-type?partyType=${partyType}`
        )
        .then((r) => {
          return r.data;
        });
    },
    uploadDocument({ commit, dispatch }, model) {
      return ajax.post("BusinessParties/api/Agents", model);
    },
    getDocuments({ commit, dispatch }, agentId) {
      return ajax.get(`/BusinessParties/api/AgentsQuery/${agentId}`);
    },
    deleteDocuments({ commit, dispatch }, model) {
      return ajax.delete(
        "BusinessParties/api/Agents",
        { data: model },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    },

    uploadSupplierDocument({ commit, dispatch }, model) {
      return ajax.post("BusinessParties/api/Suppliers", model);
    },
    getSupplierDocuments({ commit, dispatch }, supplierId) {
      return ajax.get(`/BusinessParties/api/SuppliersQuery/${supplierId}`);
    },
    deleteSupplierDocuments({ commit, dispatch }, model) {
      return ajax.delete(
        "BusinessParties/api/Suppliers",
        { data: model },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    },
  },
};
